import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { PrintHidden } from '#/components/PrintHidden/PrintHidden';
import { H5 } from '#/components/Text/H5';
import { colors, cssBreakpoints } from '#/theme/theme';

import { PageToolbar_Box_1, PageToolbar_Box_2 } from './PageToolbar.styled';

const ToolBox = styled.div`
  margin-top: 12px;

  @media (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 0;
  }

  > *:not(:first-child) {
    margin-left: 12px;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-left: 20px;
    }
  }

  button,
  a {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      min-width: 120px;
    }
  }
`;

type Props = {
  message?: ReactNode;
  tools?: ReactNode;
  light?: boolean;
  centered?: boolean;
};

export function PageToolbar({ message, tools, light, centered }: Props) {
  return (
    <PrintHidden>
      <PageToolbar_Box_2
        style={{
          justifyContent: centered ? 'center' : 'space-between',
          background: light ? colors.inputGrey : colors.brandBlue,
          color: light ? colors.brandBlue : 'white',
        }}
      >
        <PageToolbar_Box_1 data-centered={centered ? true : undefined}>
          {message && (
            <H5 tag="div" style={{ margin: 0, textAlign: 'center' }}>
              {message}
            </H5>
          )}
        </PageToolbar_Box_1>
        {tools && (
          <ToolBox
            style={{
              paddingBlock: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '0 0 auto',
            }}
          >
            {tools}
          </ToolBox>
        )}
      </PageToolbar_Box_2>
    </PrintHidden>
  );
}
